import React, { lazy, Suspense, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import { FaSpinner } from "react-icons/fa";

const Homebanner = lazy(() => import("../../components/Homebanner/Homebanner"));
const TrendingNow = lazy(() =>
  import("../../components/TrendingNow/TrendingNow")
);
const Offers = lazy(() => import("../../components/Offers/Offers"));
const BookingSteps = lazy(() =>
  import("../../components/Bookingsteps/BookingSteps")
);
const CarCollection = lazy(() =>
  import("../../components/CarCollection/CarCollection")
);
const WhyWowcarz = lazy(() => import("../../components/WhyWowcarz/WhyWowcarz"));
const FAQ = lazy(() => import("../../components/FAQ/FAQ"));
const Downloadapp = lazy(() =>
  import("../../components/Downloadapp/Downloadapp")
);
const Journey = lazy(() => import("../../components/Journey/Journey"));
const Partners = lazy(() => import("../../components/Partners/Partners"));
const ExploreIndia = lazy(() =>
  import("../../components/ExploreIndia/ExploreIndia")
);
const FinalCTA = lazy(() => import("../../components/FinalCTA/FinalCTA"));

const Home = () => {
  useEffect(() => {
    localStorage.removeItem("bookingvalues");
  }, []);
  const stickyFinalCTA = (
    <Suspense fallback={null}>
      <div style={{ position: 'sticky', top: 0, zIndex: 1 }}>
        <FinalCTA />
      </div>
    </Suspense>
  );

  return (
    <div>
      <Layout beforeFooter={stickyFinalCTA}>
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-[500px]">
              <span className="animate-pulse flex text-xl font-medium text-[#f95552]">
                <FaSpinner className="animate-spin text-red-500 text-2xl" />
                <img src="/assets/logo.png" className="w-48 h-20" loading="lazy" />
              </span>
            </div>
          }
        >
          <Homebanner />
          <TrendingNow />
          <Offers />
          <BookingSteps />
          <CarCollection />
          <WhyWowcarz />
          <Downloadapp />
          <FAQ />
          <Partners />
          {/* Not part of the mobile design — desktop/tablet only */}
          <div className="hidden md:block">
            <ExploreIndia />
          </div>
        </Suspense>
      </Layout>
    </div>
  );
};

export default Home;
